import { useChangeLanguage } from "@/hooks/useChangeLanguage";
import { readStoredLocale } from "@/i18n/persistence";
import { useEffect } from "react";
import {
  Navigate,
  Outlet,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";

const SUPPORTED = ["en", "fr"];

export default function LocaleLayout() {
  const navigate = useNavigate();

  const changeLanguage = useChangeLanguage();

  const { lang } = useParams<{ lang: string }>();
  const inValidLanguage = !lang || !SUPPORTED.includes(lang);

  const location = useLocation();
  // Strip the first segment "/xx" and keep the rest
  const rest = location.pathname.replace(/^\/[^/]+/, "") || "/";

  useEffect(() => {
    if (inValidLanguage) {
      return;
    }

    async function applyLocale() {
      const stored = readStoredLocale();
      if (stored) {
        navigate(rest);
      } else {
        changeLanguage(lang as "en" | "fr");
      }
    }

    applyLocale();
  }, [lang]);

  if (inValidLanguage) {
    return <Navigate to={rest} replace />;
  }

  return <Outlet />;
}
